export const InputFieldMessage = ({ text }: { text?: string }) => {
  return (
    <span className="text-red-600 text-sm italic">
      {text ? text : "This field is required and cannot be empty"}
    </span>
  );
};
